import React, { PropsWithChildren } from 'react'
import cn from 'classnames'

import styles from './styles.module.scss'

interface SubmitButtonProps extends PropsWithChildren {
  id?: string
  isLoading?: boolean
  isSucceed?: boolean
  className?: string
}

const SubmitButton = (props: SubmitButtonProps) => {
  const { children, id, isLoading, isSucceed, className } = props

  return (
    <button
      id={id}
      type="submit"
      className={cn(styles.button, className, { [styles.loading]: isLoading || isSucceed })}
      disabled={isLoading}
    >
      {children}

      <div
        className={cn(styles.loader, { [styles.shown]: isLoading, [styles.hidden]: !isLoading })}
      >
        {isLoading && (
          <svg className={styles.spinner} viewBox="0 0 50 50">
            <circle className={styles.path} cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
          </svg>
        )}
      </div>
    </button>
  )
}

export default SubmitButton
